import "@fontsource/plus-jakarta-sans/latin-400.css";
import "@fontsource/plus-jakarta-sans/latin-500.css";
import "@fontsource/plus-jakarta-sans/latin-700.css";
import "@fontsource/plus-jakarta-sans/latin-800.css";
import "./styles.css";
import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { registerSW } from "virtual:pwa-register";
import { App } from "./app/App";
import { ErrorBoundary } from "./app/ErrorBoundary";
import { CACHE_MAX_AGE, persistOptions } from "./lib/persist";
import { ToastProvider } from "./lib/toast";

const queryClient = new QueryClient({
  // gcTime ≥ maxAge van de persister, anders verdwijnen bewaarde gegevens na 5 minuten.
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: true, gcTime: CACHE_MAX_AGE } },
});

// Service worker (offline app-shell, tekeningen en foto's); werkt zichzelf bij op de achtergrond.
registerSW({ immediate: true });

// Na een update bestaan de onderdelen van de vorige versie niet meer. Een open app die zo'n onderdeel
// nog wil laden, herlaadt één keer en krijgt dan de nieuwe versie.
window.addEventListener("vite:preloadError", (e) => {
  try {
    if (sessionStorage.getItem("pw-reloaded")) return;
    sessionStorage.setItem("pw-reloaded", "1");
  } catch {
    /* geen opslag: toch herladen */
  }
  e.preventDefault();
  window.location.reload();
});
window.addEventListener("load", () =>
  setTimeout(() => {
    try {
      sessionStorage.removeItem("pw-reloaded");
    } catch {
      /* geen opslag */
    }
  }, 10_000),
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <BrowserRouter>
        <ToastProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </ToastProvider>
      </BrowserRouter>
    </PersistQueryClientProvider>
  </StrictMode>,
);
